import api from 'app/api';
import store from 'app/store';

export const getEventList = async (params, callback) => {
  const {
    searchText,
    selectedPage,
    pageSize,
    businessConfigId,
  } = params;

  const successCallback = ({ data }) => {
    let eventsList = data?.[searchText]?.data || [];
    if (searchText === 'draft') {
      eventsList = eventsList.map((item) => {
        const { payload, ...rest } = item;
        return { ...payload, ...rest, id: rest?._id  };
      });
    } else if (searchText === 'upcoming') {
      eventsList.push(...data?.upcomingDtls?.data?.map((item) => {
        const { payload, ...rest } = item;
        return { ...payload, ...rest, id: rest?._id  };
      }));
    }
    store.dispatch({ type: 'EVENT_LIST:DATA:SET', data: eventsList });

    if (callback) callback(data);
  };

  await api.post(
    `/events/${businessConfigId}`,
    {
      live: false,
      past: false,
      draft: false,
      upcoming: false,
      [searchText]: true,
    },
    {
      id: 'get-event-list',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        page_no: selectedPage || 0,
        page_size: pageSize || 100,
      },
    },
  );
};

export const deleteEvent = async (id, isDraft, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.delete(
    `/events/primary/${id}`,
    {
      id: 'delete',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        isDraft,
      },
    },
  );
};

export const getBusinessConfig = async (id, reducerPrefix = 'EVENT_LIST') => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: `${reducerPrefix}:BUSINESS_CONFIG:SET`, data });
  };

  await api.get(
    `/organisers/configs/${id}`,
    {
      id: 'save-business-config',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const updateBusinessConfig = async (id, payload, reducerPrefix = 'EVENT_LIST', callback) => {
  const successCallback = ({ data }) => {
    console.log(data);
    store.dispatch({ type: `${reducerPrefix}:BUSINESS_CONFIG:SET`, data });

    if (callback) callback(data);
  };

  return await api.put(
    `/organisers/configs`,
    payload,
    {
      id: 'save-business-config',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const getAllEventsList = async (businessConfigId, params) => {
  const successCallback = ({ data }) => {
    store.dispatch({
      type: 'EVENT_LIST:EVENTS_COUNT:SET',
      data: {
        live: data?.live?.data || [],
        draft: data?.draft?.data || [],
        upcoming: data?.upcomingDtls?.data || [],
        past: data?.past?.data || [],
      },
    });
  };

  await api.post(
    `/events/${businessConfigId}`,
    {
      past: true,
      draft: true,
      upcoming: true,
      live: true,
      ...params,
    },
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
      params: {
        page_no: 0,
        page_size: 1,
      },
    },
  );
};
